const PanelContainer = {
  baseStyle: {
    px: {base: "8px", md: "15px"},
    py: {base: "20px", md: "30px"},
    minHeight: "calc(100vh - 123px)",
  },
};

export const PanelContainerComponent = {
  components: {
    PanelContainer,
  },
};
